
<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title [innerHTML]="data.title"></h2>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <div *ngIf="data.message">
    {{ data.message }}
  </div>

  <div *ngIf="data.descripcion">
    <mat-icon>delete</mat-icon>
    ¿Está seguro que desea eliminar el registro "{{ data.descripcion }}"?
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">

  <app-button-delete-and-cancel (deleteClicked)="doAction()" (cancelClicked)="closeDialog()" [isDialogClose]="true"></app-button-delete-and-cancel>
</mat-dialog-actions>
